export default __webpack_public_path__ + "static/media/scarringActive.d684d69d.svg";